export var createFontStyle = function (size, fontFamily) {
    return size + "px " + fontFamily;
};
